
import { defineComponent } from 'vue'
import RedirectEvents from './RedirectEvents.vue'
import AffiliateLogs from './AffiliateLogs.vue'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'Logs',
  components: { RedirectEvents, AffiliateLogs },
  computed: {
    ...mapState('authModule', ['isMB']),
    activeTab: {
      get() {
        return this.tab
      },
      set(value) {
        this.tab = value
      },
    },
  },
  data: function() {
    return {
      tab: 'affiliate-logs',
    }
  },
  methods: {
    backToStats() {
      const params = JSON.parse(this.$route.params.filters as any)
      this.$router.push({
        name: 'statistics',
        params: {
          filters: this.$route.params.filters,
          ...('vertical' in params ? { vertical: params.vertical } : {}),
        },
      })
    },
  },
})
